import { render, staticRenderFns } from "./MedicalRecordList.vue?vue&type=template&id=1e6cd4ca&"
import script from "./MedicalRecordList.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports